export enum EAgentSettings {
	TOGGLE_RATE_CALL_SURVEY = 'toggleRateCallSurvey',
	ALLOW_VOICEMAILS = 'allowVoicemails',
	CALL_TRANSFER_RINGING_TONE = 'callTransferRingingTone',
}
